import { Globe, Monitor, ShieldCheck } from 'lucide-react'

interface TakeoverRequestCardProps {
  data: {
    systemName?: string
    domain?: string
    loginUrl?: string
    message?: string
  }
  onUseInternal?: () => void
  onUseUserBrowser?: () => void
  onContinue?: () => void
  isActive?: boolean
}

export function TakeoverRequestCard({
  data,
  onUseInternal,
  onUseUserBrowser,
  onContinue,
  isActive = false,
}: TakeoverRequestCardProps) {
  const systemLabel = data.systemName || data.domain || 'systemet'

  return (
    <div className="automation-card" style={{ marginTop: 12 }}>
      <div className="automation-card-header">
        <div>
          <span className="automation-card-badge">
            <ShieldCheck size={12} />
            {isActive ? 'Takeover aktiv' : 'Trenger takeover'}
          </span>
          <div className="automation-card-title">
            {isActive ? `Fullfør innlogging i ${systemLabel}` : `Studio trenger hjelp i ${systemLabel}`}
          </div>
        </div>
        <Globe size={16} style={{ color: '#7d7d7d', flexShrink: 0 }} />
      </div>

      <p className="automation-card-desc">
        {data.message || `Denne flyten traff en innlogging, 2FA eller captcha i ${systemLabel}. Når dette er fullført, kan samme kjøring fortsette videre.`}
      </p>

      {data.loginUrl && (
        <div className="automation-card-field">
          <span className="automation-card-label">Login-URL</span>
          <span className="automation-card-value">{data.loginUrl}</span>
        </div>
      )}

      <div className="automation-card-actions">
        {!isActive && (
          <button className="automation-card-btn automation-card-btn-primary" onClick={onUseInternal}>
            <Monitor size={13} style={{ marginRight: 6, verticalAlign: 'text-bottom' }} />
            Start takeover
          </button>
        )}
        <button className="automation-card-btn automation-card-btn-secondary" onClick={onUseUserBrowser}>
          <Globe size={13} style={{ marginRight: 6, verticalAlign: 'text-bottom' }} />
          Bruk min nettleser
        </button>
        {isActive && (
          <button className="automation-card-btn automation-card-btn-primary" onClick={onContinue}>
            Fortsett run
          </button>
        )}
      </div>
    </div>
  )
}
